/* lp-sticky-cta — <lp-sticky-cta>: show after N px scrolled, hide while a buy area (<lp-buy-box>,
   <lp-set-switcher>, <lp-bundle-buy> or <lp-video-buy>) is in view. Image and name follow the buy box (lp:product-change) or the set switcher's
   piece and colour (lp:selection).
   Quick nav (data-nav, 01/10/2026): the bar is a page navigation — [data-lp-nav-link] pills scroll to their anchors
   (lp-base.js), the pill of the section under the screen's middle gets aria-current, and the bar never hides for
   a buy area. */
(function () {
  'use strict';
  if (window.customElements.get('lp-sticky-cta')) return;
  class LpStickyCta extends HTMLElement {
    connectedCallback() {
      this.showAfter = parseInt(this.dataset.showAfter, 10) || 600;
      this.buyBoxVisible = false;
      this.nav = this.hasAttribute('data-nav');
      this.onScroll = this.update.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.nav) { this.links = Array.prototype.slice.call(this.querySelectorAll('[data-lp-nav-link]')); this.paintLinks(); this.update(); this.spy(); return; }
      var boxes = document.querySelectorAll('lp-buy-box, lp-set-switcher, lp-bundle-buy, lp-video-buy');
      if (boxes.length && 'IntersectionObserver' in window) {
        var self = this, seen = [];
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { var i = seen.indexOf(e.target); if (e.isIntersecting && i < 0) seen.push(e.target); if (!e.isIntersecting && i > -1) seen.splice(i, 1); });
          self.buyBoxVisible = seen.length > 0;
          self.update();
        }, { threshold: 0.1 });
        Array.prototype.forEach.call(boxes, function (b) { self.io.observe(b); });
      }
      this.update();
      this.followBuyBox();
    }
    /* the image and name follow the buy area: the buy box's product, or the set switcher's piece and colour */
    followBuyBox() {
      var img = this.querySelector('.lp-sticky-cta__img'), title = this.querySelector('[data-lp-product-title]'), sub = this.querySelector('[data-lp-product-sub]');
      if (!img || !title) return;
      var self = this;
      var show = function (name, colour, src, alt) {
        title.textContent = name; title.removeAttribute('data-lp-fallback-text');
        if (sub) { sub.textContent = colour || ''; sub.hidden = !colour; }
        if (src) { img.removeAttribute('srcset'); img.src = src.replace(/width=\d+/, 'width=160'); img.alt = alt || name; img.hidden = false; }
      };
      var applyBox = function (handle) {
        var box = document.querySelector('lp-buy-box'); if (!box || !box.products) return false;
        var p = box.products[handle || box.dataset.handle]; if (!p) return false;
        show(p.title, '', p.images && p.images[0] ? p.images[0].src : '', p.images && p.images[0] ? p.images[0].alt : '');
        return true;
      };
      var applySwitcher = function () {
        var sw = document.querySelector('lp-set-switcher'); if (!sw || !sw.selection) return false;
        var sel = sw.selection(); show(sel.title, sel.colour, sel.image, sel.title + (sel.colour ? ' in ' + sel.colour : ''));
        return true;
      };
      var tries = 0, tryApply = function () { if (!applyBox() && !applySwitcher() && tries++ < 40) setTimeout(tryApply, 300); };
      tryApply();
      if (window.LP) {
        this.offChange = window.LP.on('product-change', function (e) { applyBox(e.detail && e.detail.handle); });
        this.offSelection = window.LP.on('selection', function (e) { var d = e.detail || {}; if (d.title) show(d.title, d.colour, d.image, d.title + (d.colour ? ' in ' + d.colour : '')); });
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.io) this.io.disconnect();
      if (this.offChange) this.offChange();
      if (this.offSelection) this.offSelection();
      if (this.spyRaf) cancelAnimationFrame(this.spyRaf);
      if (this.trackRaf) cancelAnimationFrame(this.trackRaf);
    }
    update() {
      if (this.nav && !this.spyRaf) { var self = this; this.spyRaf = requestAnimationFrame(function () { self.spyRaf = 0; self.spy(); self.followHeader(); }); }
      if (this.nav && this.classList.contains('lp-sticky-cta--top')) this.followHeader();
      var show = window.pageYOffset > this.showAfter && !this.buyBoxVisible;
      if (show === !this.hidden) return;
      this.hidden = !show;
      document.documentElement.style.setProperty('--lp-sticky-cta-height', show ? this.offsetHeight + 'px' : '0px');
      /* at the top edge (phones) the bar covers the top of the page: anchor scrolls (lp-base.js) land below it */
      var atTop = this.classList.contains('lp-sticky-cta--top');
      document.documentElement.style.setProperty('--lp-sticky-cta-top-height', show && atTop ? this.offsetHeight + 'px' : '0px');
    }
    /* top edge: sit under the store header wherever it is right now — it is sticky and hides on scroll, so its
       bottom edge is measured rather than assumed (0 once it has slid away) */
    followHeader() {
      if (!this.classList.contains('lp-sticky-cta--top')) return;
      var hd = document.querySelector('.header'), top = 0;
      if (hd) { var r = hd.getBoundingClientRect(); top = Math.max(0, Math.floor(r.bottom)); }
      if (top !== this.headerTop) { this.headerTop = top; this.style.top = top + 'px'; }
      /* 15/10/2026: the header slides in and out with a transition and no scroll events fire while it moves, so keep
         re-measuring each frame until its bottom edge has held still (or 600 ms) — no gap or overlap mid-slide */
      if (!this.trackRaf) { var self = this, still = 0, start = performance.now(); this.trackRaf = requestAnimationFrame(function step() {
        var h = document.querySelector('.header'), t = h ? Math.max(0, Math.floor(h.getBoundingClientRect().bottom)) : 0;
        if (t !== self.headerTop) { self.headerTop = t; self.style.top = t + 'px'; still = 0; } else still++;
        if (still < 6 && performance.now() - start < 600) self.trackRaf = requestAnimationFrame(step); else self.trackRaf = 0;
      }); }
    }
    /* each link takes the colour of the section it scrolls to: the tint a <lp-video-buy> carries (--lp-video-buy-tint,
       from the theme's swatch setting). Sections without one keep the bar's own surface. */
    paintLinks() {
      var self = this;
      this.links.forEach(function (a) {
        var el = window.LP ? window.LP.resolveTarget(a.dataset.lpNavLink) : document.getElementById(a.dataset.lpNavLink);
        var host = el && (el.closest('lp-video-buy') || el.querySelector('lp-video-buy'));
        var tint = host ? getComputedStyle(host).getPropertyValue('--lp-video-buy-tint').trim() : '';
        var on = tint && window.LP && window.LP.onHex ? window.LP.onHex(tint) : null;
        if (tint) a.style.setProperty('--lp-sticky-cta-link-bg', tint); else a.style.removeProperty('--lp-sticky-cta-link-bg');
        if (on) { a.style.setProperty('--lp-sticky-cta-link-text', on.text); a.style.setProperty('--lp-sticky-cta-halo', on.halo); }
        else { a.style.removeProperty('--lp-sticky-cta-link-text'); a.style.removeProperty('--lp-sticky-cta-halo'); }
      });
    }
    /* quick nav: the link whose section spans the screen's middle is current; above the first or between sections the
       nearest one above wins, so one pill is always lit once the page has scrolled past the first anchor */
    spy() {
      if (!this.links || !this.links.length) return;
      var mid = window.innerHeight * 0.45, best = null, bestTop = -Infinity;
      this.links.forEach(function (a) {
        var el = window.LP ? window.LP.resolveTarget(a.dataset.lpNavLink) : document.getElementById(a.dataset.lpNavLink); if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= mid && r.top > bestTop) { bestTop = r.top; best = a; }
      });
      if (best === this.current) return;
      this.current = best;
      var nav = this.querySelector('[data-lp-nav]');
      this.links.forEach(function (a) { if (a === best) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      /* keep the lit pill in view inside the strip without moving the page */
      if (best && nav && nav.scrollWidth > nav.clientWidth) {
        var l = best.offsetLeft, r = l + best.offsetWidth, to = null;
        if (l < nav.scrollLeft) to = l - 8; else if (r > nav.scrollLeft + nav.clientWidth) to = r - nav.clientWidth + 8;
        if (to !== null) nav.scrollTo({ left: to, behavior: window.LP && window.LP.motionOK ? 'smooth' : 'auto' });
      }
    }
  }
  window.customElements.define('lp-sticky-cta', LpStickyCta);
})();
